import Device from '@/Enums/Device.enum';
import DeviceId from '@/Enums/DeviceId.enum';
import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import type { IDevice, IDeviceControlOption } from '@/Interfaces/Device.interface';

export const deviceLabelMap: Record<DeviceId, string> = {
  [DeviceId.TV]: Device.TV,
  [DeviceId.Mobile]: Device.Mobile,
  [DeviceId.Tablet]: Device.Tablet,
  [DeviceId.Desktop]: Device.Desktop,
  [DeviceId.GamesConsole]: Device.GamesConsole,
};

export const deviceIdToControlOption = (deviceIds: DeviceId): IControlOption => {
  return { value: deviceIds, label: deviceLabelMap[deviceIds] };
};

export const devicesToControlOptions = (devices: IDevice[] | undefined | null): IDeviceControlOption[] => {
  return (devices ?? []).map(device => ({ value: device.id, label: device.name }));
};
